import { Channel } from './skill';

export interface Timeseries {
    label: string;
    timestamps: number[];
    values: number[];
}

export interface SolomonLabel {
    value: string;
    text: string;
}

export interface SolomonLabels {
    commands: {
        [Channel.AliceSkill]: SolomonLabel[];
        [Channel.SmartHome]: SolomonLabel[];
    };
    sources: {
        [Channel.AliceSkill]: SolomonLabel[];
        [Channel.SmartHome]: SolomonLabel[];
    };
}

export interface MonitoringQuery {
    source: string;
    command: string;
    from: string | number;
    to: string | number;
}

export enum ChartType {
    Bar = 'bar',
    Area = 'area',
}

type Bar = Record<string, number> & { from: number; to: number };

export { Bar as BarType };

interface ChartData {
    [ChartType.Area]: Timeseries[];
    [ChartType.Bar]: Bar[];
}

interface ChartMeta<T extends ChartType = ChartType> {
    id: string;
    type: T;
    data: ChartData[T];
    yAxisLabel?: string;
    yAxisThreshold?: number;
    yAxisThresholdLabel?: string;
    displayErrorTypeSwitch?: boolean;
}

export interface DashboardRowMeta<U extends ChartMeta[] = ChartMeta[]> {
    charts: U;
    text: string;
}

export type AreaChartType = ChartMeta<ChartType.Area>;
export type BarChartType = ChartMeta<ChartType.Bar>;
